<template>
    <div class="page-content" id="patrol-form">
        <Titlebar :incrustation="'fa-history'" :backPath="'/patrols/list'">
            <h1>{{ pageTitle }}</h1>
        </Titlebar>
        <div class="container-fluid full-height" v-if="patrol">
            <div class="row justify-content-center full-height">
                <div class="col-6 col-xl-5">
                    <UiCard>
                        <form class="form p-0">
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.label') }}</label>
                                <div class="col-8">
                                    <input type="text"
                                        v-model="patrol.name"
                                        name="name"
                                        class="form-input col"
                                        v-validate
                                        data-vv-rules="required"
                                        :data-vv-as="$t('patrol.form.label')"
                                    />
                                    <span class="form-input-error" v-show="showErrors['name'] && errors.has('name')"
                                        @click="hideError('name')">{{ errors.first('name') }}</span>
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.description') }}</label>
                                <div class="col-8">
                                    <textarea v-model="patrol.description"
                                        name="description"
                                        class="form-input col"
                                        v-validate
                                        data-vv-rules="max:255"
                                        :data-vv-as="$t('patrol.form.label')">
                                    </textarea>
                                </div>

                                <span class="form-input-error"
                                    v-show="showErrors['description'] && errors.has('description')"
                                    @click="hideError('description')">{{ errors.first('description') }}</span>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.manageTravelTime') }}</label>
                                <div class="col col-no-padding">
                                    <UiSwitch v-model="patrol.manageTravelTime"/>
                                </div>
                            </div>
                            <div class="form-row row" v-show="patrol.manageTravelTime">
                                <label class="col-4">{{ $t('patrol.form.theoricStartAt') }}</label>
                                <div class="col col-no-padding">
                                    <input type="text" v-inputmask="'99:99'" v-model.lazy="patrol.theoricStartAt" @blur="handleChangeStartAt" class="form-input clock-picker-handler"/>
                                    <!--<ClockPicker v-model="patrol.theoricStartAt" :inputclass="'form-input'"
                                                :mini="true" :nullable="true"></ClockPicker>-->
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.profile') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="patrolProfiles"
                                        class="from-top"
                                        v-model="patrolProfiles"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="profiles"
                                        label="label"
                                        track-by="profileId"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span class="d-inline-flex align-items-center text-truncate">
                                                <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                                <span>{{ option.label }}</span>
                                            </span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="d-inline-flex align-items-center text-truncate">
                                                <ProfileIcon v-if="option.meta.icon" :icon="option.meta.icon" class="mr-2" />
                                                <span>{{ option.label }}</span>
                                            </span>
                                        </template>
                                    </multiselect>
                                    <small class="form-text text-muted">{{$t('patrol.form.profileHelp')}}</small>
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.group') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="patrolGroups"
                                        class="from-top"
                                        v-model="patrolGroups"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="groups"
                                        label="label"
                                        track-by="id"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                    </multiselect>
                                    <small class="form-text text-muted">{{$t('patrol.form.groupHelp')}}</small>
                                </div>
                            </div>
                            <div class="form-row row">
                                <label class="col-4">{{ $t('patrol.form.dati') }}</label>
                                <div class="col-8">
                                    <multiselect
                                        id="patrolDatis"
                                        class="from-top"
                                        v-model="patrolDatis"
                                        :multiple="true"
                                        :close-on-select="true"
                                        :taggable="false"
                                        placeholder=""
                                        :options="datis"
                                        label="label"
                                        track-by="id"
                                        @blur="modification"
                                        @tag="modification"
                                        @select="modification"
                                        @remove="modification"
                                    >
                                        <template slot="option" slot-scope="{ option }">
                                            <span>{{ option.label }}</span>
                                        </template>
                                        <template slot="tag" slot-scope="{ option }">
                                            <span class="tag-content">
                                                {{ option.label || option.name }}
                                            </span>
                                            <template v-if="option.from">
                                                <div class="tooltip bottom" style="width: 140px;bottom: calc(100% + 5px); right: calc(50% - 14px);">
                                                    {{ option.fromObject.name || option.fromObject.label }}
                                                </div>
                                            </template>
                                        </template>
                                    </multiselect>
                                    <small class="form-text text-muted">{{$t('patrol.form.datiHelp')}}</small>
                                </div>
                            </div>
                        </form>
                    </UiCard>
                </div>

                <div class="col-6 col-xl-7">
                    <UiCard>
                        <draggable :list="patrol.checkpoints" :element="'div'" :options="draggableOptions"
                                   v-if="patrol.checkpoints && patrol.checkpoints.length > 0" @end="handleEnd">
                            <Checkpoint 
                                v-for="(checkpoint, key) in patrol.checkpoints"
                                :key="key"
                                :checkpoint="checkpoint"
                                :number="key"
                                :manageTravelTime="patrol.manageTravelTime"
                                :theoricStartAt="patrol.theoricStartAt"
                                @editCheckpoint="handleEditCheckpoint"
                                @deleteCheckpoint="handleDeleteCheckpoint"
                                @modifCheckpointSinceLast="handleModifCheckpointSinceLast"
                                @modifCheckpointHourSinceStart="handleModifCheckpointHourSinceStart"
                            />
                        </draggable>
                        <div class="checkpoint checkpoint-add">
                            <div class="col-left">
                            </div>
                            <div class="col-center" @click="openModalAddAP">
                                <div class="number"><i class="fa fa-plus"></i></div>
                                <div class="description">
                                    <span class="button-add">
                                        {{ $t('patrol.btns.addCheckpoint') }}
                                    </span>
                                </div>
                            </div>
                            <div class="col-right">
                            </div>
                        </div>
                    </UiCard>
                    <div
                        class="patrol-error"
                        v-if="!!patrolError"
                        v-html="timelineErrorMessage"
                    ></div>
                </div>
            </div>

        </div>
        <Toolbar class="justify-content-end">
            <Btn 
                class="primary" 
                :class="[{disabled:patrolError}]"
                @click.native.stop="validForm()"
                v-can="'beepiz-edit-patrols'"
            >
                {{ $t('global.save') }}
            </Btn>
            <Btn>
                <router-link to="/patrols/list" tag="span">{{ $t('global.cancel') }}</router-link>
            </Btn>
        </Toolbar>

        <Modal ref="modalAddAP" class="ActionPointsModal" :width="modalApWidth" :height="'100%'">
            <span slot="header" v-html="$t('ap.titles.add.ap') + ' PATROL'"></span>
            <div class="full-height scroll" slot="content" >
                <Library ref="library" :chrome="false" :patrol="true" @selectAP="handleSelectAp"
                @cancelAP="handleCancelAp"></Library>
            </div>
        </Modal>
    </div>
</template>

<script>

    import Vue from 'vue'
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import Icons from '@/services/iconMapping.js';
    import FormUtils from '@/services/form.js';
    import axios from 'axios';
    import moment from 'moment';
    import Multiselect from '@/components/ui/Multiselect'
    import _concat from 'lodash/concat'
    import _filter from 'lodash/filter'
    import _map from 'lodash/map'
    import _findIndex from 'lodash/findIndex'

    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import UiCard from "@/components/ui/Card";
    import UiSwitch from "@/components/ui/Switch";
    import Btn from "@/components/ui/Button";
    import ClockPicker from '@/components/ui/datetime/TimePicker';

    import Modal from '@/components/ui/Modal';
    import Library from '@/views/actionpoints/library/Library';

    import Checkpoint from '@/components/patrols/Checkpoint';
    import ProfileIcon from '@/components/profiles/ProfileIcon';

    import draggable from 'vuedraggable';


    export default {
        name: 'PatrolsHome',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            UiSwitch,
            ClockPicker,
            draggable,
            Modal,
            Library,
            Checkpoint,
            Multiselect,
            ProfileIcon
        },
        computed: {
            pageTitle: function () {
                if (this.editMode) {
                    return this.patrol.name;
                }
                else {
                    return Utils.t('patrol.titles.new')
                }
            },
            errors: function(){
                return this.$validator.errorBag
            }
        },
        data: () => ({

                editMode: false,
                patrol: {
                    name: '',
                    description: '',
                    manageTravelTime: false,
                    theoricStartAt: null,
                    checkpoints: []
                },
                checkpointsHasModifications: false,
                showErrors: {
                    name: false,
                    description: false,
                },
                draggableOptions: {
                    handle: '.fa-arrows-v'
                },
                modalApWidth: '100%',
                editCheckpointKey: null,
                patrolError: false,
                patrolErrorMessage: '',
                timelineErrorMessage: null,
                patrolProfiles: [],
                patrolGroups: [],
                patrolDatis: [],
                profiles: [],
                groups: [],
                datis: [],
            }
        ),
        methods: {
            validForm: function () {
                FormUtils.hideAllErrors(this);
                this.$validator.validateAll().then(() => {
                    this.saveForm();
                }).catch((error) => {
                    FormUtils.showAllErrors(this);
                });
            },
            saveForm: function () {
                window.Vfc.$refs.loading.show();
                var patrol = this.patrolTransformer(JSON.parse(JSON.stringify(this.patrol)));
                if (this.$route.meta.specialAction == 'copy' || !this.editMode) {
                    axios.post(API.endpoints.patrols.add, patrol)
                        .then(response => {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            window.V._router.push('/patrols/list');
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                            }
                            else {
                            }
                            window.Vfc.$refs.loading.hide();
                        })
                }
                else {
                    axios.put(API.route(API.endpoints.patrols.edit, {patrolId: this.$route.params.id}), patrol)
                        .then(response => {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            window.V._router.push('/patrols/list');
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    FormUtils.handleErrors(errorBag, error.response.data.message)
                                }
                                FormUtils.showAllErrors(this);
                            }
                            else {
                            }
                            window.Vfc.$refs.loading.hide();
                        })
                }

            },
            patrolTransformer: function (patrol) {


                if (!patrol.manageTravelTime) {
                    patrol.theoricStartAt = null;
                }

                if(patrol.theoricStartAt != null){
                    patrol.theoricStartAt = moment(patrol.theoricStartAt,'HH:mm:ss').format('HH:mm');
                }

                if (patrol.checkpoints && patrol.checkpoints.length > 0) {
                    //if (this.checkpointsHasModifications || this.$route.meta.specialAction == 'copy') {
                        var totalTravelTime = 0;
                        for (var i = 0; i < patrol.checkpoints.length; i++) {
                            var cp = patrol.checkpoints[i];
                            totalTravelTime += parseInt(cp.travelTimeSinceLast);
                            cp = this.checkpointTransformer(cp, !patrol.manageTravelTime,totalTravelTime);
                        }
                    /*}
                    else {
                        delete patrol.checkpoints;
                    }*/

                }

                patrol.datisToAttach = this.patrolDatis.filter(item => { return item.from === null }).map(item => { return item.id }),
                patrol.groupsToAttach = this.patrolGroups.map(item => { return item.id }),
                patrol.profilesToAttach = this.patrolProfiles.map(item => { return item.profileId })

                delete patrol.id;
                delete patrol.checkpointCount;
                delete patrol.datis;
                delete patrol.profiles;
                delete patrol.groups;


                return patrol;
            },
            checkpointTransformer: function (cp, forceZero, totalTravelTime) {
                delete cp.comment;
                delete cp.name;
                delete cp.type;
                delete cp.plans;
                if (forceZero === true) {
                    cp.delta = 0;
                    cp.travelTimeSinceStart = 0;
                }else{
                    cp.delta = cp.delta * 60;
                    cp.travelTimeSinceStart = totalTravelTime * 60;
                }
                delete cp.travelTimeSinceLast;
                delete cp.travelHourSinceStart;
                return cp;
            },
            hideError: function (key) {
                FormUtils.hideError(this, key);
            },

            openModalAddAP: function () {
                this.editCheckpointKey = null;
                var filter = null;
                if (this.patrol.checkpoints.length == 0) {
                    filter = [3, 4];
                }

                this.$refs.modalAddAP.show(this.cancelAp);
                this.$refs.library.edit(null, null, filter);
                this.$refs.library.loadList();

            },
            handleEnd: function (evt) {
            },
            handleEditCheckpoint: function (key) {
                var filter = null;
                if (key == 0) {
                    filter = [3, 4];
                }
                this.$refs.modalAddAP.show(this.cancelAp);
                this.$refs.library.edit(null, false, filter);
                this.$refs.library.loadList();
                this.editCheckpointKey = key;
            },
            handleDeleteCheckpoint: function (key) {
                this.patrol.checkpoints.splice(key, 1);
            },
            handleCancelAp: function () {
                this.$refs.modalAddAP.hide();
            },
            cancelAp: function () {

            },
            handleSelectAp: function (tabSelected) {

                this.$refs.modalAddAP.hide();

                var hour = '';
                if(this.patrol.checkpoints.length == 0 && this.patrol.theoricStartAt != null){
                    hour = this.patrol.theoricStartAt;
                }

                tabSelected.forEach((obj, idx) => {

                    if(this.patrol.checkpoints[0]){
                        if(this.patrol.checkpoints[0].id == obj.id){
                            window.Vfc.$refs.messages.sendMessage('error', Utils.t('patrol.errors.firstCheckpointNotReusable'));
                            return;
                        }
                    }

                    var checkpoint = {
                        comment: obj.comment,
                        delta: 5,
                        id: obj.id,
                        name: obj.name,
                        travelTimeSinceStart: 0,
                        travelHourSinceStart: hour,
                        travelTimeSinceLast: 0,
                        type: obj.type
                    };
                    if (this.editCheckpointKey != null) {
                        this.$set(this.patrol.checkpoints, this.editCheckpointKey, checkpoint);
                        //this.patrol.checkpoints[this.editCheckpointKey] = checkpoint;
                    }
                    else {
                        this.patrol.checkpoints.push(checkpoint);
                    }


                });


            },
            getMinTimeFromDelta(checkpoint) {
                if (checkpoint.travelHourSinceStart && checkpoint.delta != 0) {
                    return moment(checkpoint.travelHourSinceStart, 'HH:mm').subtract(checkpoint.delta, 'minutes').format('HH:mm');
                }
                return '';
            },
            getMaxTimeFromDelta(checkpoint) {
                if (checkpoint.travelHourSinceStart && checkpoint.delta != 0) {
                    return moment(checkpoint.travelHourSinceStart, 'HH:mm').add(checkpoint.delta, 'minutes').format('HH:mm');
                }
                return '';
            },
            fieldIsReadonly: function(index){
                if(this.patrol.manageTravelTime && this.patrol.theoricStartAt == null && index == 0){
                    return true;
                }
                return false;
            },
            handleModifCheckpointSinceLast: function(key, val){
                var cp =this.patrol.checkpoints[key];
                cp.travelTimeSinceLast = Math.abs(val);
                cp.travelTimeSinceStart = this.patrol.checkpoints[key-1].travelTimeSinceStart + Math.abs(val);
                for(var i=key+1;i<this.patrol.checkpoints.length;i++){
                    this.patrol.checkpoints[i].travelTimeSinceStart = this.patrol.checkpoints[i-1].travelTimeSinceStart + this.patrol.checkpoints[i].travelTimeSinceLast;
                }


                this.checkpointsHasModifications = true;
                //this.calculateTimesAndHours();
            },
            handleModifCheckpointHourSinceStart: function(key, val){
                this.checkpointsHasModifications = true;
                var cp =this.patrol.checkpoints[key];

                var valM = moment(val,'HH:mm');
                var patrolM = moment(this.patrol.theoricStartAt,'HH:mm');

                if(valM.isBefore(patrolM)){
                    cp.travelTimeSinceStart = valM.add(1,'day').diff(patrolM,'minutes');
                }
                else{
                    cp.travelTimeSinceStart = valM.diff(patrolM,'minutes');
                }


                /*if(cp.travelTimeSinceStart < 0){
                    cp.travelTimeSinceStart = 3600 + cp.travelTimeSinceStart;
                }*/



                for(var i=key;i<this.patrol.checkpoints.length;i++){
                    if(this.patrol.checkpoints[i-1]){
                        if(isNaN(this.patrol.checkpoints[i].travelTimeSinceStart)){
                            this.patrol.checkpoints[i].travelTimeSinceStart = 0;
                        }
                        if(isNaN(this.patrol.checkpoints[i-1].travelTimeSinceStart)){
                            this.patrol.checkpoints[i-1].travelTimeSinceStart = 0;
                        }
                        this.patrol.checkpoints[i].travelTimeSinceLast = this.patrol.checkpoints[i].travelTimeSinceStart - this.patrol.checkpoints[i-1].travelTimeSinceStart;
                    }
                    else{
                        this.patrol.checkpoints[i].travelTimeSinceLast = 0;
                        this.patrol.checkpoints[i].travelTimeSinceStart = 0;
                    }
                }

                if(cp.travelTimeSinceLast < 0){
                    cp.errorTime = true;
                    this.patrolError = true;
                    this.patrolErrorMessage = Utils.t('patrol.errors.incoherentCheckpoints');
                }
                else{
                    cp.errorTime = false;
                    this.patrolError = false;
                    this.patrolErrorMessage = "";
                }


                /*cp.travelHourSinceStart = val;
                cp.travelTimeSinceStart = moment(val,'HH:mm').diff(moment(this.patrol.theoricStartAt,'HH:mm'),'minutes');

                this.checkpointsHasModifications = true;*/
                //this.calculateTimesAndHours();
            },
            calculateTimesAndHours: function(){
                var totalTravelTime = 0;


                for (var i = 0; i < this.patrol.checkpoints.length; i++) {
                    var cp = this.patrol.checkpoints[i];

                        cp.travelTimeSinceLast = cp.travelTimeSinceStart - totalTravelTime;
                        totalTravelTime += cp.travelTimeSinceLast;
                        cp.travelTimeSinceLast = cp.travelTimeSinceLast;

                        cp.travelHourSinceStart = moment(this.patrol.theoricStartAt, 'HH:mm').add((cp.travelTimeSinceStart), 'minutes').format('HH:mm');

                }
            },
            handleChangeStartAt: function(){

            },

            mergeDatis(firstLoad) {
                let datis = []

                Vue.nextTick(() => {
                    this.patrolProfiles.forEach(profile => {
                        datis = _concat(datis, _map(_filter(this.datis, dati => {
                            if(dati.profile) {
                                return dati.profile.id == profile.profileId
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'profile',
                                fromObject: profile,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    this.patrolGroups.forEach(group => {
                        datis = _concat(datis, _map(_filter(this.datis ,dati => {
                            if(dati.groupId) {
                                return dati.groupId == group.id
                            }
                        }),dati => {
                            return {
                                id: dati.id,
                                label: dati.label,
                                from: 'group',
                                fromObject: group,
                                className: 'readonly',
                                readonly: true
                            }
                        }))
                    })

                    datis = _concat(datis, _filter(this.patrolDatis, dati => {
                        return dati.from === null
                    }))

                    datis = _filter(datis, (dati, index, self) =>
                        index === _findIndex(self, (t) => (
                            t.id === dati.id
                        ))
                    )

                    Vue.set(this,'patrolDatis',datis)
                })

            },
            loadProfiles: function () {
                axios.get(API.endpoints.profiles.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.profiles = response.data.data;
                        for (var i = 0; i < this.profiles.length; i++) {
                            this.profiles[i].label = this.profiles[i].meta.name
                            //this.profiles[i].nbDatis = this.profiles[i].datis.length
                        }
                        this.loadGroups();
                    })
            },
            loadGroups: function () {
                axios.get(API.endpoints.groups.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.groups = response.data.data;
                        for (var i = 0; i < this.groups.length; i++) {
                            this.groups[i].label = this.groups[i].name
                            //this.groups[i].nbDatis = this.groups[i].datis.length
                        }
                        this.loadDevices();
                    })
            },
            loadDevices: function () {

                axios.get(API.endpoints.datis.index + API.constructQueryParams({perpage: 9999999999999}))
                    .then(response => {
                        this.datis = response.data.data;
                        for (var i = 0; i < this.datis.length; i++) {
                            this.datis[i].label = this.datis[i].name
                        }

                        this.datis = this.datis.map(dati => {
                            return {
                                id: dati.id,
                                label: dati.name,
                                groupId: dati.groupId,
                                profile: dati.profile,
                                from: null
                            }
                        })

                        //this.mergeDatis()

                        window.Vfc.$refs.loading.hide();
                    })
            },
            modification: function (section,key) {
                this.mergeDatis(false)
                // this.hasModifications = true
            },
        },
        created() {
            if (!this.$route.meta.specialAction && this.$route.params.id) {
                this.editMode = true;
            }
        },
        mounted() {
            if (this.$route.params && this.$route.params.id) {
                axios.get(API.route(API.endpoints.patrols.show, {patrolId: this.$route.params.id}))
                    .then(({data}) => {
                        if (data.manageTravelTime === '1') {
                            data.manageTravelTime = true
                        } else if (data.manageTravelTime === '0') {
                            data.manageTravelTime = false
                        }
                        this.patrol = data;

                        if(this.$route.meta.specialAction == 'copy'){
                            this.patrol.name += ' (copie)';
                        }

                        for (var i = 0; i < this.patrol.checkpoints.length; i++) {
                            var cp = this.patrol.checkpoints[i];
                            this.$set(cp, 'travelHourSinceStart', '');
                            this.$set(cp, 'travelTimeSinceLast', '');
                            this.$set(cp, 'errorTime', false);
                            cp.travelTimeSinceStart = cp.travelTimeSinceStart / 60;
                            cp.delta = cp.delta / 60;
                        }
                        this.calculateTimesAndHours();

                        let datis = []

                        let profiles = []
                        if(this.patrol.profiles) {
                            this.patrol.profiles.forEach(item => {
                                profiles.push({
                                    profileId: item.id,
                                    label: item.name,
                                    nbDatis: item.datis ? item.datis.length : 0,
                                    meta: {
                                        icon: item.icon
                                    }
                                })
                                if (item.datis) {
                                    item.datis.forEach(itemDati => {
                                        datis.push({
                                            id: itemDati.id,
                                            label: itemDati.name,
                                            from: 'profile',
                                            fromObject: item,
                                            className: 'readonly',
                                            readonly: true
                                        })
                                    })
                                }
                            })
                        }
                        this.patrolProfiles = profiles
                        let groups = []
                        if(this.patrol.groups) {
                            this.patrol.groups.forEach(item => {
                                groups.push({
                                    id: item.id,
                                    label: item.name,
                                    nbDatis: item.datis ? item.datis.length : 0,
                                })
                                if (item.datis) {
                                    item.datis.forEach(itemDati => {
                                        datis.push({
                                            id: itemDati.id,
                                            label: itemDati.name,
                                            from: 'group',
                                            fromObject: item,
                                            className: 'readonly',
                                            readonly: true
                                        })
                                    })
                                }
                            })
                        }
                        this.patrolGroups = groups

                        if(this.patrol.datis) {
                            this.patrol.datis.forEach(item => {
                                datis.push({
                                    id: item.id,
                                    label: item.name,
                                    from: null
                                })
                            })
                        }
                        Vue.set(this,'patrolDatis',datis)

                        setTimeout(() => {
                            this.checkpointsHasModifications = false;
                        }, 100);

                        this.loadProfiles();

                        //window.Vfc.$refs.loading.hide();
                    })
                    .catch(error => {
                        console.info(error)
                        if (error.response != null) {
                        }
                        else {
                        }
                    })
            }
            else {
                this.loadProfiles();
            }

        },
        watch: {
            "patrol.checkpoints": function (newValue, oldValue) {
                    this.checkpointsHasModifications = true;

                    if (newValue.length < 2) {
                        this.patrolError = true;
                        this.patrolErrorMessage = Utils.t('patrol.errors.notEnoughCheckpoints');
                    }
                    else {
                        if (newValue[0].type != 3 && newValue[0].type != 4) {
                            this.patrolError = true;
                            this.patrolErrorMessage = Utils.t('patrol.errors.wrongTypeFirstCheckpoints');
                        }
                        else {
                            if(newValue[newValue.length - 1].travelTimeSinceStart > 1440){
                                this.patrolError = true;
                                this.patrolErrorMessage = Utils.t('patrol.errors.patrolTooLong');
                            }
                            else {
                                this.patrolError = false;
                            }

                        }
                    }





            },
            "patrol.manageTravelTime": function (newValue, oldValue) {
                if (newValue === 1) {
                    if(this.patrol.theoricStartAt){
                        this.patrol.checkpoints[0].travelHourSinceStart = this.patrol.theoricStartAt;
                    }
                    else{
                        this.patrol.checkpoints[0].travelHourSinceStart = 0;
                    }

                }
            },
            "patrol.theoricStartAt": function (newValue, oldValue) {
                if(this.patrol.theoricStartAt == ""){
                    this.patrol.theoricStartAt = null;
                }
                if(this.patrol.theoricStartAt != null){
                    this.patrol.checkpoints[0].travelHourSinceStart = this.patrol.theoricStartAt;
                    this.calculateTimesAndHours();
                }

            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
